import api from './axios';

export const paymentAPI = {
  // Get athlete details for payment
  getAthleteForPayment: async (athleteId) => {
    const response = await api.get(`/payment/${athleteId}`);
    return response.data;
  },

  // Select event for athlete
  selectEvent: async (athleteId, eventId) => {
    const response = await api.post('/payment/select-event', { athleteId, eventId });
    return response.data;
  },

  // Create Razorpay order
  createOrder: async (athleteId) => {
    const response = await api.post('/payment/create-order', { athleteId });
    return response.data;
  },

  // Verify payment
  verifyPayment: async (paymentData) => {
    const response = await api.post('/payment/verify', paymentData);
    return response.data;
  },

  // Get payment status
  getPaymentStatus: async (athleteId) => {
    const response = await api.get(`/payment/status/${athleteId}`);
    return response.data;
  },

  // Download invoice
  downloadInvoice: async (athleteId) => {
    const response = await api.get(`/payment/invoice/${athleteId}`);
    return response.data;
  },

  // Event Application payment APIs
  createEventApplicationOrder: async (applicationId) => {
    const response = await api.post('/payment/event-application/create-order', { applicationId });
    return response.data;
  },

  verifyEventApplicationPayment: async (paymentData) => {
    const response = await api.post('/payment/event-application/verify', paymentData);
    return response.data;
  },

  getEventApplicationPaymentDetails: async (applicationId) => {
    const response = await api.get(`/payment/event-application/${applicationId}`);
    return response.data;
  },

  downloadEventApplicationInvoice: async (applicationId) => {
    const response = await api.get(`/payment/event-application/${applicationId}/invoice`);
    return response.data;
  },

  // ===== NEW: EVENT UPGRADE APIs =====
  
  // Check if athlete is eligible for upgrade
  checkUpgradeEligibility: async (athleteId) => {
    const response = await api.get(`/payment/upgrade/check-eligibility/${athleteId}`);
    return response.data;
  },

  // Create upgrade order
  createUpgradeOrder: async (athleteId, newEventId) => {
    const response = await api.post('/payment/upgrade/create-order', { athleteId, newEventId });
    return response.data;
  },

  // Verify upgrade payment
  verifyUpgradePayment: async (paymentData) => {
    const response = await api.post('/payment/upgrade/verify', paymentData);
    return response.data;
  },
};
